// FETCH ALL STITCHING INWARD DETAILS
export const FETCH_STITCHING_INWARD_DETAILS_REQUEST_DK = 'FETCH_STITCHING_INWARD_DETAILS_REQUEST_DK';
export const FETCH_STITCHING_INWARD_DETAILS_SUCCESS_DK = 'FETCH_STITCHING_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_STITCHING_INWARD_DETAILS_FAILURE_DK = 'FETCH_STITCHING_INWARD_DETAILS_FAILURE_DK';

// FETCH ALL STITCHING INWARD DETAILS
export const FETCH_STITCHING_INWARD_DETAILS_WITHOUT_ID_REQUEST_DK = 'FETCH_STITCHING_INWARD_DETAILS_WITHOUT_ID_REQUEST_DK';
export const FETCH_STITCHING_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK = 'FETCH_STITCHING_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK';
export const FETCH_STITCHING_INWARD_DETAILS_WITHOUT_ID_FAILURE_DK = 'FETCH_STITCHING_INWARD_DETAILS_WITHOUT_ID_FAILURE_DK';

// CREATE STITCHING INWARD DETAILS
export const CREATE_STITCHING_INWARD_DETAILS_REQUEST_DK = 'CREATE_STITCHING_INWARD_DETAILS_REQUEST_DK';
export const CREATE_STITCHING_INWARD_DETAILS_SUCCESS_DK = 'CREATE_STITCHING_INWARD_DETAILS_SUCCESS_DK';
export const CREATE_STITCHING_INWARD_DETAILS_FAILURE_DK = 'CREATE_STITCHING_INWARD_DETAILS_FAILURE_DK';

// UPDATE STITCHING INWARD DETAILS
export const UPDATE_STITCHING_INWARD_DETAILS_REQUEST_DK = 'UPDATE_STITCHING_INWARD_DETAILS_REQUEST_DK';
export const UPDATE_STITCHING_INWARD_DETAILS_SUCCESS_DK = 'UPDATE_STITCHING_INWARD_DETAILS_SUCCESS_DK';
export const UPDATE_STITCHING_INWARD_DETAILS_FAILURE_DK = 'UPDATE_STITCHING_INWARD_DETAILS_FAILURE_DK';

// FETCH SINGLE STATE OF STITCHING INWARD DETAILS
export const FETCH_SINGLE_STITCHING_INWARD_DETAILS_REQUEST_DK = 'FETCH_SINGLE_STITCHING_INWARD_DETAILS_REQUEST_DK';
export const FETCH_SINGLE_STITCHING_INWARD_DETAILS_SUCCESS_DK = 'FETCH_SINGLE_STITCHING_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_SINGLE_STITCHING_INWARD_DETAILS_FAILURE_DK = 'FETCH_SINGLE_STITCHING_INWARD_DETAILS_FAILURE_DK';

// FETCH ALL PROPERTIES FROM STITCHING_INWARD DETAILS
export const FETCH_PREVIOUS_STITCHING_INWARD_DETAILS_REQUEST_DK = 'FETCH_PREVIOUS_STITCHING_INWARD_DETAILS_REQUEST_DK';
export const FETCH_PREVIOUS_STITCHING_INWARD_DETAILS_SUCCESS_DK = 'FETCH_PREVIOUS_STITCHING_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_PREVIOUS_STITCHING_INWARD_DETAILS_FAILURE_DK = 'FETCH_PREVIOUS_STITCHING_INWARD_DETAILS_FAILURE_DK';

// DELETE STITCHING INWARD DETAILS
export const DELETE_STITCHING_INWARD_DETAILS_REQUEST_DK = 'DELETE_STITCHING_INWARD_DETAILS_REQUEST_DK';
export const DELETE_STITCHING_INWARD_DETAILS_SUCCESS_DK = 'DELETE_STITCHING_INWARD_DETAILS_SUCCESS_DK';
export const DELETE_STITCHING_INWARD_DETAILS_FAILURE_DK = 'DELETE_STITCHING_INWARD_DETAILS_FAILURE_DK';

export const RESET_STITCHING_INWARD_DETAILS_INFO_DK = 'RESET_STITCHING_INWARD_DETAILS_INFO_DK';

export const CREATE_STITCHING_INWARD_DETAILS_FORM_DK = 'CREATE_STITCHING_INWARD_DETAILS_FORM_DK';

export const UPDATE_STITCHING_INWARD_DETAILS_FORM_DK = 'UPDATE_STITCHING_INWARD_DETAILS_FORM_DK';
